export default "__VITE_ASSET__8wblM6tj__"